import { NgModule } from '@angular/core';
import { PaymentComponent } from '~shared/svgs/payment/payment.component';


@NgModule({
  declarations: [
    PaymentComponent
  ],
  exports: [
    PaymentComponent
  ]
})
export class PaymentModule {}
